import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgBsToastServiceModule } from 'ng-bs-toast-service';

import { ConsultationsService } from './services/consultations/consultations.service';
import { RecordingSessionService } from './services/recording/recording-session.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        RouterModule,
        NgBsToastServiceModule,
    ],
    providers: [
        ConsultationsService,
        RecordingSessionService,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        RouterModule,
        NgBsToastServiceModule,
    ],
})
export class SharedModule {}
